var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-alert",class:[
         _vm.type ? 'app-alert--' + _vm.type : ''
     ]},[(_vm.$slots.title || _vm.type == 'error')?_c('span',{staticClass:"alert-title"},[_vm._t("title",[_vm._v("Error")])],2):_vm._e(),(_vm.$slots.default)?_c('span',[_vm._t("default")],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }